import React from 'react';
import FillGapQuestionOptions from "./FillGapQuestionOptions";
import $ from "jquery";
const parse = require('html-react-parser');


class FillGapQuestion extends React.Component{
/*    replaceAll(strTitle, search, replacement){
        return strTitle.replace(new RegExp(search,'g'),replacement);
    }*/
    /*componentDidUpdate() {
        /!*$("input.gap").last().on('onKeyPress',e=>{
            this.props.setResult(e.target.value);
            console.log('hi last')
        });*!/
        document.addEventListener("keydown", this.handleLastChange.bind(this));
    }
    handleLastChange(e){
        console.log(e)
        console.log('last change');
    }*/
    render(){
        const qOptions = this.props.frageOptions;
        const setResult = this.props.setResult;
        const setAdditionalResult = this.props.setAdditionalResult;
        let fillGapText2, fillGapText3;

        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

        if(this.props.frageTitle[2] != "") {
            if (this.props.frageTitle[2].includes('TYPE')) {
                fillGapText2 = parse(this.props.frageTitle[2], {
                    replace: function (domNode) {
                        if (domNode.data == "TYPE") {
                            return <FillGapQuestionOptions
                                qOptions={qOptions} setResult={setResult} setAdditionalResult={setAdditionalResult}
                            />

                        }
                    }
                });
            } else {

                fillGapText2 = renderHTML(this.props.frageTitle[2]);
                //fillGapText2 = this.props.frageTitle[2];
            }
        }

        if(this.props.frageTitle.length>3 && this.props.frageTitle[3] != "") {
            if (this.props.frageTitle[3].includes('TYPE')) {
                fillGapText3 = parse(this.props.frageTitle[3], {
                    replace: function (domNode) {
                        if (domNode.data == "TYPE") {
                            return <FillGapQuestionOptions
                                qOptions={qOptions} setResult={setResult} setAdditionalResult={setAdditionalResult}
                            />

                        }
                    }
                });
            } else {
                fillGapText3 = renderHTML(this.props.frageTitle[3]);
                //fillGapText3 = this.props.frageTitle[3];
            }
        }


            return (
                <div className="questionName centered">
                    <div className="questionHeading">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                    </div>
                    {fillGapText2!=""?
                    <div className="fillGapQuestionMidHeading">
                        {fillGapText2}
                    </div>:''}
                    {fillGapText3!=""?
                    <div className="fillGapQuestionMidHeading">
                        {fillGapText3}
                    </div>:''}
                </div>
            );





    }
}
export default FillGapQuestion;
